import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7f4a180d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "pmc-title"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "定价模式确认", -1));
const _hoisted_3 = {
  class: "pmc-body"
};
const _hoisted_4 = {
  class: "pmc-mode-box"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pmc-mode-label"
}, "当前生效的定价模式为：", -1));
const _hoisted_6 = {
  class: "pmc-mode-value"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pmc-tip"
}, "请注意：保存后将以此模式的数据为准，被切换隐藏的另一模式数据将不会生效。", -1));
import { computed } from 'vue';
import { ExclamationCircleFilled } from '@ant-design/icons-vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'PriceModeConfirmModal',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    // single 单一默认价格 / tiered 多默认价格
    mode: {
      type: String,
      default: 'single'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['confirm', 'cancel'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const modeLabel = computed(() => props.mode === 'tiered' ? '多默认价格' : '单一默认价格');
    const onCancel = () => emit('cancel');
    const onConfirm = () => emit('confirm');
    return (_ctx, _cache) => {
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        open: __props.open,
        width: 416,
        closable: true,
        "wrap-class-name": "price-mode-confirm-modal",
        onCancel: onCancel
      }, {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_unref(ExclamationCircleFilled), {
          class: "pmc-title-icon"
        }), _hoisted_2])]),
        footer: _withCtx(() => [_createVNode(_component_a_button, {
          onClick: onCancel
        }, {
          default: _withCtx(() => [_createTextVNode("检查一下")]),
          _: 1
        }), _createVNode(_component_a_button, {
          type: "primary",
          loading: __props.loading,
          onClick: onConfirm
        }, {
          default: _withCtx(() => [_createTextVNode("确认保存")]),
          _: 1
        }, 8, ["loading"])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(modeLabel)), 1)]), _hoisted_7])]),
        _: 1
      }, 8, ["open"]);
    };
  }
});